import { sendFeedback } from 'functions/feedback';
import * as yup from 'yup';
export const loanCalculatorvalidationSchema = yup.object({
  durationInMonths: yup.string().required('Please select duration'),
  monthlyIncome: yup.string().required('Monthly Income is required'),
  loanAmount: yup.string().required('Loan Amount is required'),
  emailAddress: yup
    .string()
    .email('Enter a valid email')
    .required('Email Address is required'),
});

export interface LoanCalculatorFormValues {
  monthlyIncome: string;
  loanAmount: string;
  emailAddress: string;
  durationInMonths: string;
}

export const handleCurrencyInput = (
  e: React.ChangeEvent<HTMLInputElement> | React.FormEvent<HTMLInputElement>,
  setFieldValue: (field: string, value: any) => void,
  fieldName: string,
  maxAmount?: number
) => {
  const target = e.target as HTMLInputElement; // force target to be input
  let { value } = target;
  // Remove all non-digit characters
  value = value.replace(/\D/g, '');

  // If empty, reset
  if (!value) {
    setFieldValue(fieldName, '');
    return;
  }

  let numericValue = Number(value);

  // Prevent exceeding max
  if (maxAmount) {
    if (numericValue > maxAmount) {
      sendFeedback(`Maximum amount is ₦${maxAmount.toLocaleString()}`);
      return;
    }
  }

  // Format with commas
  const formattedValue = numericValue.toLocaleString();

  setFieldValue(fieldName, formattedValue);
};

// generate options for loan duration

export const generateDurationOptions = (months: number) => {
  return Array.from({ length: months }, (_, i) => {
    const month = i + 1;
    return {
      label: `${month} ${month === 1 ? 'month' : 'months'}`,
      value: month.toString(),
    };
  });
};
export function normalizeMoney(value: string | number): number {
  if (typeof value === 'number') return value;
  return Number(value.replace(/,/g, ''));
}
